import { useState } from "react";
import { faqs } from "@/mocks/home";
import SectionHeading from "./SectionHeading";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="w-full bg-background-50 px-4 md:px-8 py-16 md:py-24">
      <div className="max-w-4xl mx-auto">
        <SectionHeading
          eyebrow="常见问答"
          title="关于本站与这类创作，你可能想问"
          desc="这里汇总了浏览时最常见的疑问。点击问题即可展开答案，再次点击收起。"
          align="center"
        />

        <div className="mt-10 md:mt-12 flex flex-col gap-3">
          {faqs.map((item, idx) => {
            const isOpen = openIndex === idx;
            return (
              <div
                key={item.q}
                className="rounded-lg bg-background-100 border border-background-200/70 overflow-hidden"
              >
                <h3>
                  <button
                    type="button"
                    aria-expanded={isOpen}
                    onClick={() => setOpenIndex(isOpen ? null : idx)}
                    className="w-full flex items-center justify-between gap-4 px-5 py-4 md:px-6 md:py-5 text-left cursor-pointer"
                  >
                    <span className="font-heading text-base md:text-lg font-bold text-foreground-950">
                      {item.q}
                    </span>
                    <i
                      className={`shrink-0 text-xl text-primary-500 ${
                        isOpen ? "ri-subtract-line" : "ri-add-line"
                      }`}
                    ></i>
                  </button>
                </h3>
                {isOpen ? (
                  <div className="px-5 pb-5 md:px-6 md:pb-6">
                    <p className="text-sm text-foreground-600 leading-relaxed border-l-2 border-accent-300 pl-4">
                      {item.a}
                    </p>
                  </div>
                ) : (
                  <div className="hidden" aria-hidden="true">
                    <p>{item.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}